import { components } from '@common/types';
import { theme } from '@store';

type TimeOffStatus = components['schemas']['FilteredUserTimeOff']['status'];

const statusColorMap = {
  ongoing: theme.palette.success.main,
  upcoming: theme.palette.warning.main,
  past: theme.palette.grey[600],
} as const satisfies Record<TimeOffStatus, string>;

export const getTimeOffStatusColor = (status: TimeOffStatus) =>
  statusColorMap[status] ?? 'lightGrey';

export const TimeOffStatusLabels = {
  ongoing: 'Ongoing',
  upcoming: 'Upcoming',
  past: 'Past',
} as const satisfies Record<TimeOffStatus, string>;
